export const APPOINTMENTS = "APPOINTMENTS";
export const MOBILE = "MOBILE";
export const SURVEY = "SURVEY";
export const DEBQ = "DEBQ";

